import { getTypography } from '@creditas-ui/utilities';
import { styled, css, keyframes } from '@creditas-ui/system';

export const Responsible = styled.div`
  width: 100%;
  padding: 25px 0px 0px 0px;
`;

export const Paragraph = styled.p`
  line-height: 4vh;
`;

export const Bold = styled.p`
  margin-top: 25px;
  margin-bottom: 10px;
  font-weight: 700;
`;

export const Toogle = styled.div``;

export const ResponsibleData = styled.div`
  width: 100%;
  justify-content: space-between;
  float: right;
`;
export const TitleResponsible = styled.div`
  float: left;
  cursor: pointer;
`;

export const ToogleIconArrow = styled.div`
  float: right;
  cursor: pointer;
`;
